'use client';

import type { IStepActionStatus } from '../use-step-action';

interface IStepLogPanelProps {
  status: IStepActionStatus;
  log: string;
}

export function StepLogPanel({ status, log }: IStepLogPanelProps): React.ReactNode {
  if (status === 'idle') {
    return null;
  }
  return (
    <pre className="max-h-[60vh] min-h-64 overflow-auto rounded bg-muted p-3 text-xs whitespace-pre-wrap">
      {log || (status === 'running' ? 'Starting…' : '')}
    </pre>
  );
}
